import { jsx } from "react/jsx-runtime";
import { cn } from "../../utils/cn.js";
import { sliderHistogramVariants } from "./SliderHistogram.variants.js";
function SliderHistogram({ histogram, min, rangeValues, emphasis = 'regular', containerClass = '' }) {
    const { container, barActive, barInactive } = sliderHistogramVariants({
        emphasis
    });
    const maxCount = histogram.counts.length ? Math.max(...histogram.counts) : 0;
    return /*#__PURE__*/ jsx("div", {
        className: cn(container(), containerClass),
        "data-testid": "histogram",
        children: histogram.counts.map((count, i)=>{
            const binStart = min + i * histogram.binWidth;
            const binEnd = binStart + histogram.binWidth;
            const isActive = rangeValues ? binEnd > rangeValues[0] && binStart < rangeValues[1] : false;
            const heightPct = maxCount > 0 ? count / maxCount * 100 : 0;
            return /*#__PURE__*/ jsx("div", {
                "data-testid": "histogram-bar",
                className: cn(isActive ? barActive() : barInactive()),
                style: {
                    height: `${heightPct}%`
                }
            }, binStart);
        })
    });
}
export { SliderHistogram };
